/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="clientPoint.module.ts" />

module Meevo.Plugins.ClientPoint {
    import ISearchColumn = Meevo.Model.ISearchColumn;
    import SortDirection = Meevo.Model.SortDirection;

    class ClientPointController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {
        public displayNameColumnsCustom: ISearchColumn;
        public coColumnsSustom: Array<ISearchColumn>;

        static $inject = [
            "meevo.AppSettings",
            "meevo.components.common.DataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService",
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            "$rootScope",
            "$scope",
            "$state",
            "meevo.ContextParams",
            'meevo.components.short-cuts.ShortCutsService',
            "meevo.components.busy.BusyService",
            "$translate",
            "$timeout",
            "meevo.plugins.clientPoint.ClientPointService",
            "$q"];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected contextParams: Meevo.IContextParams,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $translate: angular.translate.ITranslateService,
            protected $timeout: angular.ITimeoutService,
            protected clientPointService: Meevo.Plugins.ClientPoint.IClientPointService,
            protected $q: ng.IQService) {

            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

            this.initialEditSection = "SECTION_MAIN";

            this.displayNameColumnsCustom = {
                header: this.$translate.instant('LABEL_CLIENT_IMAGE_INITIALS'),
                fieldName: 'lastName',
                sortDirection: SortDirection.Ascending,
                width: 20
            };

            this.coColumnsSustom = [
                { header: this.$translate.instant('LABEL_NAME'), fieldName: 'lastName', sortDirection: null, width: 'auto' },
                { header: this.$translate.instant('LABEL_TOTAL_POINTS'), fieldName: 'remainingAmount', sortDirection: null, width: 33 },
                { header: this.$translate.instant('LABEL_TOTAL_VALUE'), fieldName: 'remainingAmount', sortDirection: null, width: 33 }
            ];

            this.busyService.start();
            this.clientPointService.getSettings().finally(() => {
                this.busyService.stop();

                if (this.$scope.criteria)
                    this.setIsGlobal(this.$scope.criteria);

                if(this.contextParams.params && this.contextParams.params.client_TId) {
                    this.visualState = Model.MaintenanceFormVisualState.Detail;
                    this.selectedItemId = this.contextParams.params.client_TId;
                }
            });
        }

        setIsGlobal(criteria) {
            //first search, when LocalSearchOnly = true (Global checkbox is hidden), in CO - has to be Global, otherwise based on another settings
            if (!criteria.defaultsApplied) {
                criteria.isGlobal = this.identityService.inCentralOfficeMode() || this.clientPointService.settings["allowViewingRedemption"];
                criteria.defaultsApplied = true;
            }
        }

       /**
       * Creates the context for editing/adding an item.
       * @return {}
       */
        createContext(): void {
            this.busyService.start();
            this.securityService.checkSection(this.meevoSecurityKeys.MANAGEMENT_CLIENTPOINT).then(() => {
                this.busyService.stop();
                this.context = new ClientPointContext(this.appSettings, this.dataService, this.modalService, this.identityService, this.loggingService, this.securityService, this.trackingService, this.$timeout, this.customDataContextConfig, this.clientPointService, this.busyService, this.$q, this.$rootScope);
                this.context.activate(
                    this.selectedItemId,
                    this.contextParams.params && this.contextParams.params.client_TId ? 'SECTION_HISTORY' : "SECTION_MAIN",
                    this.asLocationId
                );
                this.context.deactivate = () => {
                    this.selectedItemId = null;
                    this.visualState = Model.MaintenanceFormVisualState.Search;
                };
                // Use translate service to populate field list
                this.context.locationFieldList =
                    [
                        { field: 'ObjectState', label: this.$translate.instant("HEADER_POINTS"), checked: false }
                    ];
            }).finally(() => {
                this.busyService.stop();
            });
        }

        preSearchCallback(criteria, rootCriteria) {
            criteria.includeAddress = true;
            this.setIsGlobal(criteria);
        }
    }

    angular.module("meevo.plugins.clientPoint")
        .controller("meevo.plugins.clientPoint.ClientPointController", ClientPointController);
}
